import { resources } from "@constants/hardcoded-strings";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import { mapEntitiesWithNameAndIdToSelectOptions } from "@utils/select-option-mapping-util";
import { useMemo } from "react";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";

type MessageTemplateSelectFormGroupProps = BaseSelectFormGroupProps & {
    messageTemplates: Array<FormattedMessageTemplate>
    selectedType: string;
};

export const MessageTemplateSelectFormGroup = (props: MessageTemplateSelectFormGroupProps) => {
    const { messageTemplates, onChange, selectedType, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const messageTemplateOptions = useMemo(() => {
        const filteredTemplates = messageTemplates.filter(template => template.type == selectedType);
        return mapEntitiesWithNameAndIdToSelectOptions(filteredTemplates);
    }, [messageTemplates, selectedType]);

    return (
        <div>
            <SelectFormGroup
                controlId={`${idPrefix}-message-template-select`}
                label={resources.common.inputs.messageTemplate.label}
                ariaLabel={resources.common.inputs.messageTemplate.label}
                automationId={`${idPrefix}-message-template-select`}
                onChange={onChange}
                options={messageTemplateOptions}
                selectedOption={selectedOption}
                disabled={disabled}
                isRequired={isRequired}
                isSearchable={isSearchable}
                isClearable={isClearable}
                labelWidth={labelWidth}
            />
        </div>
    );
};